import React from "react";

import classes from "./styles.module.scss";

import House from "~assets/images/icons/JSX/House";
import SharedModel from "~assets/images/icons/JSX/SharedModel";

const TEXT_MAP = {
    TRANSFER_IN: "From:",
    TRANSFER_OUT: "To:",
    "SPENT.PARAMETRIC": "Analysis:",
    "SPENT.INSIGHTS": "Model:",
    "SPENT.COMMUNITY": "Community:",
};

const URL_SELECTOR = {
    "SPENT.PARAMETRIC": "/parametric-analysis/analysis",
    "SPENT.INSIGHTS": "/models",
    "SPENT.COMMUNITY": "/communities",
};

const getUrl = (type, id) => {
    const baseUrl = URL_SELECTOR[type] || "/";
    return `${baseUrl}/${id}`;
};

const AddDetails = ({ spent = {}, transfer = {}, transactionType = "" }) => {
    const { name: spentName = "", id: spentId = "" } = spent || {};
    // const { user: { username: transferName = "" } = {} } = transfer || {};

    let transferName = transfer?.user?.name || transfer?.user?.username || transfer?.name || "";

    if (transfer?.feature === "LEGACY_TRANSFER") {
        transferName = "Legacy Credit Transfer";
    }

    const isTransfer = transactionType === "TRANSFER_IN" || transactionType === "TRANSFER_OUT";
    const isTransferIn = transactionType === "TRANSFER_IN";
    const isSpentType = transactionType.includes("SPENT");

    return (
        <div className={classes.addDetailsContainer}>
            {(isTransfer || isSpentType) && (
                <>
                    <div className={classes.iconWithTitle}>
                        {isTransfer ? (
                            <SharedModel fill="#646F81" />
                        ) : (
                            <House color="#F58020" width="16px" height="16px" />
                        )}
                        <span>{TEXT_MAP[transactionType] || ""}</span>
                    </div>
                    <div>
                        {isTransfer ? (
                            <span className={classes.nameText}>{transferName || "-"}</span>
                        ) : (
                            <a href={getUrl(transactionType, spentId)} className={classes.linkText}>
                                {spentName || "-"}
                            </a>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

export default AddDetails;
